import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './ComponentWithTooltip.scss';

const ComponentWithTooltip = ({ options, tooltipText, children, id }) => (
  <OverlayTrigger
    delay={{ ...options.delay }}
    overlay={(props) => (
      <Tooltip id={id} {...props}>
        {tooltipText}
      </Tooltip>
    )}
    placement={options.placement}
  >
    <span>{children}</span>
  </OverlayTrigger>
);

ComponentWithTooltip.propTypes = {
  options: PropTypes.shape({
    placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    delay: PropTypes.shape({ show: PropTypes.number, hide: PropTypes.number })
  }),
  tooltipText: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  id: PropTypes.oneOf(['button-floating-tooltip', 'hidden-tooltip'])
};
ComponentWithTooltip.defaultProps = {
  options: { placement: 'top', delay: { show: 250, hide: 400 } },
  id: 'button-floating-tooltip'
};
export default ComponentWithTooltip;
